module.exports = __webpack_public_path__ + "img/zenfone10.9ff935d2.jpg";